import React from "react";
import styles from "./index.module.scss";
import { useTranslations } from "next-intl";

interface AdminPrivacyInfoModalProps {
  visible: boolean;
  onClose: () => void;
  uid?: string | number | null;
  email?: string | null;
  ip?: string | null;
  location?: string | null;
  lastLoginTime?: string | null;
}

const formatValue = (value?: string | number | null) => {
  if (value === null || value === undefined || value === "") {
    return "--";
  }
  return String(value);
};

const AdminPrivacyInfoModal: React.FC<AdminPrivacyInfoModalProps> = ({
  visible,
  onClose,
  uid,
  email,
  ip,
  location,
  lastLoginTime,
}) => {
  const t = useTranslations();

  if (!visible) return null;

  return (
    <div className={styles.mask} onClick={onClose}>
      <div className={styles.container} role="dialog" aria-modal="true" aria-label="用户信息" onClick={(e) => e.stopPropagation()}>
        <div className={styles.title}>用户信息</div>
        <div className={styles.content}>
          <div className={styles.row}>
            <span className={styles.label}>UID：</span>
            <span className={styles.value}>{formatValue(uid)}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>{t('user_profile_admin_email_label')}</span>
            <span className={styles.value}>{formatValue(email)}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>IP：</span>
            <span className={styles.value}>{formatValue(ip)}<span className={styles.separator}>|</span>{t('user_profile_admin_location_label')}{formatValue(location)}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>{t('user_profile_admin_last_login_label')}</span>
            <span className={styles.value}>{formatValue(lastLoginTime)}</span>
          </div>
        </div>
        <button className={styles.confirmButton} type="button" onClick={onClose}>
          确定
        </button>
      </div>
    </div>
  );
};

export default AdminPrivacyInfoModal;
